import React, { Component } from 'react';
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Toaster from "toastr";
import Breadcrumbs from "react-breadcrumbs";
import Constants from "../../../configurations/constants";
import Messages from "../../../configurations/messages";
import DisputesAPI from "../../../api/DisputesApi";
import Util from "../../../util/util";
import BulkUpdateStatusFilter from './BulkUpdateStatusFilter';
import BulkUpdateStatusTable from './BulkUpdateStatusTable';

class BulkUpdateStatus extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
          actionLoading: false,
          tableData: [],
          totalCount: 0,
          selectedDispute: null,
          loading: false,
          showTable: false,
          pages: 0,
          pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
          pageNum: 0, //Zero based index
          filterParams: null,
          stop_pinging: false,
          generating: [],
          reportsProgress: [],
          transactionGroups: [],
          selection: [],
          selectAll: false,
          params: {},
          resetSelection: false
        }
    }
    paginateid = (index) => {
        const offset = parseInt(this.state.pageNum, 0);
        //const idx = parseInt(index, 0);
        const pagesize = parseInt(this.state.pageSize, 0);
        const result =
          offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
        return result.toString();
    }
    onTableChange =(state, instance)=> {
        let pageSize = instance.state.pageSize;
        let pageNum = instance.state.page; //table page  - Zero based index
        this.setState({ pageSize: pageSize, pageNum: pageNum });
        if (this.state.filterParams) {
          let params = Util.clone(this.state.filterParams);
          params.pageSize = pageSize;
          params.pageNum = pageNum + 1;
    
          this.onSearchHandler(params);
        }
    }
    onDisputeRowClick=(index)=> {
        this.setState({ selectedDispute: this.state.tableData[index] });
    }
    onSearchHandler = (params, resetPageNumber) => {
        //Reset states
        let stateUpdate = { loading: true, tableData: []};
        if (resetPageNumber) {
          stateUpdate.pageNum = 0;
          params.pageNum = 1;
        }
        this.setState(stateUpdate, () => {
        params.pageSize = params.pageSize || this.state.pageSize;
        params.pageNum = params.pageNum || this.state.pageNum + 1;
        DisputesAPI.getDisputesUpdateStatus(params)
          .then(response => {
            let data = response.data.content;
            data = data.map(d => {
              return {
                ...d,
                createdOn: Util.toUserLocalTime(d.createdOn)
              };
            });
            let totalCount = response.data.count;
            let pages = totalCount
              ? Math.ceil(
                  totalCount /
                    (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
                )
              : 0;
            if (data.length === 0) Toaster.warning("No records found.", "Disputes Updates");
    
            this.setState({
              tableData: data,
              loading: false,
              filterParams: params,
              totalCount: totalCount,
              pages: pages
            });
          })
          .catch(error => {
            console.log(error);
            Util.errorMessageToast(Toaster, error.data, [
              `${Messages.ERROR_DISPUTES_UPDATE_SEARCH}`,
              ''
            ]);
            this.setState({ loading: false });
          });
        }); 
    }
    
    onParamChange = params => {
      this.setState({ params })
    }
   
    render() {
        return (
            <div>
                <div id="page-breadcrumb" className="breadcrumb-container">
                  <Breadcrumbs
                    separator={Constants.BREADCRUMB_SEPARATOR}
                    routes={this.props.routes}
                    params={this.props.params}
                  />
                </div>
                <PageTitle title="Bulk Updates Status" />
                <BulkUpdateStatusFilter 
                  onSearchHandler={this.onSearchHandler} 
                  updateParentTG={this.onTransactionGroupChange} 
                  updateParentParams={this.onParamChange}
                  loading={this.state.loading}
                />
                <Divider />
                <BulkUpdateStatusTable 
                  onRowClick={this.onDisputeRowClick}
                  tableData={this.state.tableData}
                  loading={this.state.loading}
                  onTableChange={this.onTableChange}
                  page={this.state.pageNum}
                  pageSize={this.state.pageSize}
                  pages={this.state.pages}
                  defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
                  paginatedCallBack={this.paginateid}
                />
            </div>
        )
    }
}
export default BulkUpdateStatus;



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/bulk_update_status/BulkUpdateStatus.js